export const program_type = {
  // 小程序
  applet: 0,
  // 官网
  official_website: 1,
  // 公用
  common: 2
}

export const content_type = {
  // logo
  logo: 1,
  // 轮播图
  banner: 2,
  // 关于我们
  introduce: 3,
  // 首页服务范围
  homeService: 4,
  // 首页新闻中心
  homeNewCenter: 5,
  // 前五条新闻
  topNews: 6,
  // 关于我们
  aboutUs: 7,
  // 服务范围
  services: 8,
  // 新闻中心
  newCenter: 9,
  // 公司新闻
  companyNews: 10,
  // 行业新闻
  industryNews: 11
}

export const program_type_select = [
  { value: 0, label: '小程序' },
  { value: 1, label: '官网' },
  { value: 2, label: '共用' }
]

export const content_type_select = [
  { value: 1, label: 'logo' },
  { value: 2, label: '轮播图' },
  { value: 3, label: '首页关于我们' },
  { value: 4, label: '首页服务范围' },
  { value: 5, label: '首页新闻中心' },
  { value: 6, label: '前五条新闻' },
  { value: 7, label: '关于我们' },
  { value: 8, label: '服务范围' },
  { value: 9, label: '新闻中心' },
  { value: 10, label: '公司新闻' },
  { value: 11, label: '行业新闻' }
]
